import React from "react";

const SignatureFeatures = () => {
  const leftItems = [
    {
      since: "UK's #1 Choice",
      title: "MEET & GREET PARKING",
      text: "Drive straight to your terminal, hand your keys to a professional valet, and walk to check-in. No shuttle, no stress. Our meet & greet partners are fully vetted, insured, and CCTV-monitored — giving you complete peace of mind from the moment you arrive.",
      buttonText: "EXPLORE OPTIONS"
    },
    {
      since: "Best Value",
      title: "PARK & RIDE",
      text: "Park your car at a secure off-airport facility and hop on a free shuttle to your terminal. Park & Ride is the most budget-friendly way to travel — ideal for longer trips where savings really add up. Compare providers and book in minutes.",
      buttonText: "COMPARE PRICES"
    }
  ];

  const rightItems = [
    {
      since: "Save Up To 70%",
      title: "Why book with AirportParkingDeals.co.uk?",
      text: "We compare official airport parking, off-airport providers, meet & greet, and park & ride — all in one place. No hidden fees, transparent pricing, and instant confirmation. Thousands of UK travellers trust us every year to find the best deal.",
      buttonText: "BOOK NOW"
    },
    {
      since: "All Major Airports",
      title: "Covering every major UK airport.",
      text: "From Heathrow and Gatwick to Manchester, Birmingham, Stansted, Luton, and Bristol — we cover all major UK airports. Whether you're flying from the North or South Terminal, we have the right parking option for your journey.",
      buttonText: "VIEW AIRPORTS"
    }
  ];

  return (
    <section className="w-full bg-[#F5F7F8] font-poppins py-5 md:py-10 overflow-hidden">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10">

        {/* Header Section */}
        <div className="flex flex-col md:flex-row justify-between items-start gap-6 mb-5 md:mb-10">
          {/* Left Title */}
          <div className="flex items-center gap-2">
            <span className="text-[13px] font-black tracking-wide text-[#00261E]">
              Parking services
            </span>
            <svg className="w-4 h-4 text-[#00261E] fill-current" viewBox="0 0 24 24">
              <path d="M10 17l5-5-5-5v10z" />
            </svg>
          </div>

          {/* Right Large Heading */}
          <h2 className="text-[28px] sm:text-[36px] md:text-[40px] lg:text-[46px] font-bold uppercase text-[#2B3131] leading-[1.1] tracking-tighter max-w-2xl text-left md:text-right">
            SECURE, AFFORDABLE PARKING AT EVERY MAJOR UK AIRPORT.
          </h2>
        </div>

        {/* Timeline Section - Robust Two Column Layout */}
        <div className="relative w-full max-w-[1000px] mx-auto flex flex-col md:flex-row">

          {/* Central Dotted Line (Desktop only) */}
          <div className="hidden md:block absolute left-1/2 top-0 bottom-0 w-[2px] border-l-[2px] border-dotted border-[#00261E]/40 -translate-x-1/2 z-0" />

          {/* Circle at Top of Center Line */}
          <div className="hidden md:block absolute top-0 left-1/2 w-2.5 h-2.5 rounded-full bg-[#00261E] -translate-x-1/2 -translate-y-1/2 z-10" />

          {/* LEFT COLUMN */}
          <div className="w-full md:w-1/2 flex flex-col gap-5 md:gap-24 md:pr-12 lg:pr-20 z-10">
            {leftItems.map((item, idx) => (
              <div key={`left-${idx}`} className="relative flex flex-col items-start md:items-end w-full">

                {/* Connector Line (Left side -> Center) */}
                <div className="hidden md:flex absolute top-[68px] -right-12 lg:-right-20 w-12 lg:w-20 items-center">
                  <div className="w-2 h-2 rounded-full bg-[#00261E]" />
                  <div className="flex-1 border-t-[2px] border-dotted border-[#00261E]/40" />
                </div>

                {/* Header info */}
                <div className="flex flex-col items-start md:items-end mb-5 text-left md:text-right">
                  <img src={require("../../../common/images/icon.webp")} alt="Icon" className="w-12 h-12 lg:w-14 lg:h-14 object-contain mb-2" />
                  <span className="text-[15px] mr-4 font-black text-[#00261E] uppercase tracking-wider">{item.since}</span>
                  <h3 className="text-[20px] lg:text-[24px] font-black uppercase text-[#00261E] tracking-tight ">
                    {item.title}
                  </h3>
                </div>

                {/* Gray Box */}
                <div className="bg-[#E5E7EB] p-6 lg:p-8 rounded-[16px] w-full flex flex-col items-start md:items-end">
                  <p className="text-[13px] lg:text-[14px] text-gray-700 font-medium leading-relaxed mb-6 text-left md:text-right">
                    {item.text}
                  </p>
                  <button className="bg-[#00261E] text-white text-[10px] font-bold uppercase tracking-widest px-6 py-2.5 rounded-full hover:bg-[#EEFE3E] hover:text-[#00261E] transition-all">
                    {item.buttonText}
                  </button>
                </div>
              </div>
            ))}
          </div>

          {/* RIGHT COLUMN (Staggered down with padding-top) */}
          <div className="w-full md:w-1/2 flex flex-col gap-5 md:gap-24 md:pl-12 lg:pl-20 pt-5 md:pt-40 z-10">
            {rightItems.map((item, idx) => (
              <div key={`right-${idx}`} className="relative flex flex-col items-start w-full">

                {/* Connector Line (Center -> Right side) */}
                <div className="hidden md:flex absolute top-[68px] -left-12 lg:-left-20 w-12 lg:w-20 items-center">
                  <div className="flex-1 border-t-[1.5px] border-dotted border-[#00261E]/40" />
                  <div className="w-2 h-2 rounded-full bg-[#00261E]" />
                </div>

                {/* Header info */}
                <div className="flex flex-col items-start mb-5 text-left">
                  <img src={require("../../../common/images/icon.webp")} alt="Icon" className="w-12 h-12 lg:w-14 lg:h-14 object-contain mb-2" />
                  <span className="text-[15px] ml-4 font-black text-[#00261E] uppercase tracking-wider">{item.since}</span>
                  <h3 className="text-[20px] lg:text-[24px] font-black text-[#00261E] leading-snug tracking-tight  max-w-sm">
                    {item.title}
                  </h3>
                </div>

                {/* Gray Box */}
                <div className="bg-[#E5E7EB] p-6 lg:p-8 rounded-[16px] w-full flex flex-col items-start">
                  <p className="text-[13px] lg:text-[14px] text-gray-700 font-medium leading-relaxed mb-6 text-left">
                    {item.text}
                  </p>
                  <button className="bg-[#00261E] text-white text-[10px] font-bold uppercase tracking-widest px-6 py-2.5 rounded-full hover:bg-[#EEFE3E] hover:text-[#00261E] transition-all">
                    {item.buttonText}
                  </button>
                </div>
              </div>
            ))}
          </div>

        </div>
      </div>
    </section>
  );
};

export default SignatureFeatures;
